import React, {useState} from 'react'
import styled from 'styled-components'
import { Visible, useScreenClass } from 'react-grid-system'
import { Link } from 'react-router-dom'
import { IconButton } from 'adl'

import useDocumentScrollThrottled from 'utility/useDocumentScrollThrottled'

const AppHeaderWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding-left: ${props => props.theme.dimensions.leftMenuWidth}px;
  transition: background-color 300ms ease, box-shadow 300ms ease;
  ${props => props.solid ? `
      background-color: rgba(255, 255, 255, 0.5);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
      backdrop-filter: blur(10px);
    `: null};
`

const AppHeaderContent = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
`

const MINIMUM_SCROLL = 8;

export default ({ onMenuClicked }) => {
  const screenClass = useScreenClass()
  const [shouldBeSolid, setShouldBeSolid] = useState(false);

  useDocumentScrollThrottled(callbackData => {
      const { currentScrollTop } = callbackData;
      const isMinimumScrolled = currentScrollTop > MINIMUM_SCROLL;

      setShouldBeSolid(isMinimumScrolled);

    });

  return (
    <AppHeaderWrapper
      solid={shouldBeSolid}
      style={{
        paddingLeft: ['xs', 'sm', 'md'].includes(screenClass) ? 0 : null
      }}
    >
      <AppHeaderContent>
        <Visible xs sm md>
          <IconButton size={32} onClick={onMenuClicked}>
            <i className="icon-menu" />
          </IconButton>
        </Visible>
        <div style={{ marginLeft: 'auto' }}>
          <IconButton size={32} as={Link} to="/" style={{ marginRight: 16 }}>
            <i className="icon-envelope" />
          </IconButton>
          <IconButton size={32} as={Link} to="/">
            <i className="icon-user" />
          </IconButton>
        </div>
      </AppHeaderContent>
    </AppHeaderWrapper>
  )
}
